import { QuestionStep, FormResponses } from '@/types/solidarity';

// Pre-shuffled attitudes questions array to maintain consistent order
const ATTITUDES_ORDER = ['P01_A', 'P01_B', 'P01_C', 'P01_D', 'P01_E', 'P01_F', 'P01_G'];

export const getQuestionSteps = (): QuestionStep[] => {
  const fixedSteps: QuestionStep[] = [
    // Volunteering Section
    {
      id: 'Q02',
      section: 'volunteering',
      questionKey: 'Q02',
      shouldShow: () => true,
      isRequired: true
    },
    {
      id: 'Q03',
      section: 'volunteering',
      questionKey: 'Q03',
      shouldShow: (responses) => responses.volunteering.Q02 === 1,
      isRequired: true
    },
    {
      id: 'Q04',
      section: 'volunteering',
      questionKey: 'Q04',
      shouldShow: (responses) => responses.volunteering.Q03 === 1,
      isRequired: true
    },
    {
      id: 'Q10',
      section: 'volunteering',
      questionKey: 'Q10',
      shouldShow: (responses) => {
        const { Q04_A, Q04_B, Q04_C, Q04_D } = responses.volunteering;
        return (Q04_A || Q04_B || Q04_C) && !Q04_D;
      },
      isRequired: true
    },
    {
      id: 'Q12',
      section: 'volunteering',
      questionKey: 'Q12',
      shouldShow: (responses) => responses.volunteering.Q02 === 1,
      isRequired: true
    },
    
    // Donations Section
    {
      id: 'D01_new',
      section: 'donations',
      questionKey: 'D01_new',
      shouldShow: () => true,
      isRequired: true
    },
    {
      id: 'D07',
      section: 'donations',
      questionKey: 'D07',
      shouldShow: (responses) => responses.donations.D01_new === 1,
      isRequired: true
    },
    {
      id: 'D13',
      section: 'donations',
      questionKey: 'D13',
      shouldShow: (responses) => responses.donations.D01_new === 1,
      isRequired: true
    },
    {
      id: 'D16',
      section: 'donations',
      questionKey: 'D16',
      shouldShow: () => true,
      isRequired: true
    },
    {
      id: 'D17',
      section: 'donations',
      questionKey: 'D17',
      shouldShow: () => true,
      isRequired: true
    }
  ];
  
  // Add attitudes steps with consistent order
  const attitudesSteps: QuestionStep[] = ATTITUDES_ORDER.map(key => ({
    id: key,
    section: 'attitudes' as const,
    questionKey: key,
    shouldShow: () => true,
    isRequired: true
  }));
  
  return [...fixedSteps, ...attitudesSteps];
};